"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledResizeHandle = void 0;
const ui_components_1 = require("@groupby/ui-components");
const react_resizable_panels_1 = require("react-resizable-panels");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledResizeHandle = (0, styled_components_1.default)(react_resizable_panels_1.PanelResizeHandle) `
  width: ${({ theme }) => theme.spacing(0.5)};
  &:hover {
    background-color: ${ui_components_1.baseColors.primaryGray200};
  }
`;
